<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="max-width: 800px; padding-top: 100px">
                    <h1 class="pt-5 pb-5">Вход</h1>

                    <p class="py-3" style="font-size: 18px">Все ваши данные были сохранены. Заново заполнять не придется.
                        <br>
                        <br>Введите номер телефона, который вы указывали при расчете полиса.</p>

                    <v-layout row wrap pb-2>
                        <v-flex xs12 sm9 pt-0>
                            <v-text-field
                                v-model="phone"
                                :rules="[rules.required, rules.phone]"
                                label="Телефон"
                                mask="+7 ### ### ## ##"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout pt-5 pb-2 row wrap>
                        <v-flex xs12>
                                <v-checkbox
                                    v-model="loginApproved"
                                    :rules="[rules.approvePrivacyPolicy]"
                                    validate-on-blur
                                >
                                    <template v-slot:label>
                                        <div class="policy-wrapper">
                                            При входе я принимаю <a class="policy" target="_blank" href="https://getpolis.ru/public-offer">условия договора</a> 
                                            и соглашаюсь с
                                            <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">
                                                <br/>Политикой обработки персональных данных</a>
                                                и даю
                                                <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                                    <br/>Согласие на обработку персональных данных
                                                </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                        </v-flex>
                    </v-layout>

                    <v-layout pb-5 row wrap>
                        <v-flex xs6 sm5 md4>
                            <v-btn @click="submit"
                                   :disabled="false"
                                   class="submit-button block">Войти</v-btn>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-form>
        </v-content>

    </v-app>
</template>

<script>
    import ymMixin from '../mixins/ym';

    export default {
        mixins: [ymMixin],

        data: () => ({
            valid: true,
            phone: '+7 ',
            loginApproved: false,
            rules: {
                required: v => !!v || 'Обязательное поле',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
                approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
    },
        }),

        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.reachGoal('click_vhod');
                    this.submitForm();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.$vuetify.goTo('.error--text', {
                            duration: 600,
                            offset: 150,
                            easing: 'easeInCubic',
                        });
                    });
                }
            },

            submitForm() {
                axios.post('/login', {
                    phone: this.phone,
                    loginApproved: this.loginApproved
                }).then(response => {
                    window.location.href = response.data.redirectTo;
                }).catch(error => {
                    console.log(error.response);
                    if (error.response.status === 419) {
                        window.location.reload();
                    } else {
                        PNotify.error(error.response.data.message);
/*                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(function (item) {
                                error.response.data.errors[item].forEach(v => PNotify.alert(v))
                            });
                        }*/
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important ;

        height: 65px;
        background-color: #00ba57 !important;;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    a.policy {
    color: #00ba57;
    }

    .policy-wrapper {
    text-align: left;
    display: table-cell;
    vertical-align: middle;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 70px;
        line-height: 1.1;
    }

    .btn-link {
        padding: 20px 10px 0;
        display: block;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/SmsLogin.vue